import { useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import ReactGA from 'react-ga4';

// Images
import { arrow, itemCheck } from '../../assets/images/dashboard-business';
import { checkedLogo, uncheckedLogo } from '../../assets/images/formAfterSignUp';

// stylesheet
import styles from './index.module.css';
import { TServiceCharge } from '../../types';
import { registerNetcoreActivity } from '../../utils/registerActivity';
import { useAppSelector } from '../../app/hooks';

type TProps = {
  selected: boolean;
  title: string;
  items: string[];
  price?: string;
  subtitle?: string;
  handleClick: () => void;
  packkage: TServiceCharge;
};

const info = () => {
  Modal.info({
    title: 'Hi, welcome to the business hub',
    content: (
      <div>
        <p className=' font-Poppins text-white'>Dear Esteemed Customer,</p>
        <p className=' font-Poppins text-white'>
          To connect with us, kindly send an email to{' '}
          <a href='mailto:hello@thebusinesshub.ng'>
            <span className={styles.email}>hello@thebusinesshub.ng</span>
          </a>{' '}
          and one of our agents will get back to you. Thanks.
        </p>
      </div>
    ),
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onOk() {},
  });
};

const Card = ({ selected, title, subtitle, items, price, handleClick, packkage }: TProps) => {
  const borderStyle = selected ? styles.selectedBorder : styles.unselectedBorder;
  const details = useAppSelector((state) => state.auth.loggedInUserDetails);

  const navigate = useNavigate();

  const isEnable =
    title === 'Business Name' ||
    subtitle === 'Less than 1 million shares' ||
    subtitle === 'For NGOs, Religious Bodies, etc';

  const navigateTo = () => {
    if (isEnable) {
      title === 'Business Name'
        ? navigate(
            `/my-business/business-registration?step=1&id=${packkage.id}&name=${packkage.title}`,
            {},
          )
        : subtitle === 'Less than 1 million shares'
        ? navigate(
            `/my-business/limited-liability?step=1&id=${packkage.id}&name=${packkage.title}`,
            {},
          )
        : subtitle === 'For NGOs, Religious Bodies, etc' &&
          navigate(
            `/my-business/incorporated-trustee?step=1&id=${packkage.id}&name=${packkage.title}`,
            {},
          );
    } else {
      info();
    }
  };
  return (
    <div
      className={`${[styles.cardContainer, borderStyle].join(
        ' ',
      )} cursor-pointer flex flex-col justify-between`}
      onClick={() => handleClick()}
    >
      <div>
        <div className='flex flex-row justify-between gap-x-15 items-start'>
          <div>
            <p className='font-bold text-[#229698] font-poppins'>{title}</p>
            <p className='text-[13px] h-8 font-poppins'>{subtitle}</p>
          </div>
          <div>
            <img src={selected ? checkedLogo : uncheckedLogo} alt='checker.jpg' />
          </div>
        </div>

        <hr />

        <div className='mt-3'>
          {items.map((item, index) => (
            <div key={item} className='flex mt-2.5 sm:mt-3 lg:mt-2.5'>
              <img src={itemCheck} alt='item.jpg' className='px-2' />
              <p className='text-[12px] font-poppins'>{item}</p>
            </div>
          ))}
        </div>
      </div>
      <div>
        <hr />

        <div className='mt-[20px] sm:mt-[22px] lg:mt-[20px] flex flex-row justify-between items-center'>
          <>
            <div className='flex flex-row items-center'>
              <span className={[styles.cardCurrency, 'font-poppins'].join(' ')}>NGR</span>
              <b className={[styles.price, 'font-poppins'].join(' ')}>
                {price ? Number(price)?.toLocaleString() : '00'}
              </b>
            </div>
            <div>
              <button
                // disabled={!isEnable}
                className={`${styles.cardButton} flex flex-row gap-x-1 items-center font-poppins h-[30px]`}
                onClick={() => {
                  registerNetcoreActivity(
                    {
                      emailAddress: details?.email,
                      firstName: details?.firstName,
                      lastName: details?.lastName,
                      mobileNumber: details?.phoneNumber,
                    },
                    'TBH_BUSINESS_REGISTRATION_STEP_2',
                  );
                  ReactGA.event({
                    category: 'formSubmit',
                    action: 'TBH_BUSINESS_REGISTRATION_STEP_2',
                    label: 'TBH_BUSINESS_REGISTRATION_STEP_2',
                    // value: 1
                  });
                  navigateTo();
                }}
              >
                {isEnable ? `Take This Offer` : 'Contact us'}
                <img src={arrow} alt='arrwo.jpg' />
              </button>
            </div>
          </>
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default Card;
